import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Breadcrumb, Spin, Table, Button } from 'antd';
import { useInvoices } from './useInvoices';
import NotaryLienModal from './NotaryLienModal';
import errorHandler from '~/Utils/errorHandler';
import LienWaiverContract from './lienWaiverContract';
import { EyeOutlined } from '@ant-design/icons';
import { BreadcrumbCustom } from '~/styles/global';
import Box from '~/components/Box';
import PageTitle from '~/components/PageTitle';
import { useTranslation } from 'react-i18next';
import DefaultLayout from '~/pages/_layouts/full';

export default function NotaryDashboard() {
  const { t } = useTranslation();
  const token = useSelector(state => state.auth.token);
  const { invoices, loading, refresh } = useInvoices(9);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [lienWaiverVisible, setLienWaiverVisible] = useState(false);

  const onLienClick = useCallback(record => {
    setSelectedRecord(record);
    setLienWaiverVisible(true);
  }, []);

  const handleNotaryClick = useCallback(record => {
    setSelectedRecord(record);
    setModalVisible(true);
  }, []);

  const handleSave = useCallback(
    async updatedRecord => {
      try {
        // Simulate invoice update
        await fetch(`${process.env.REACT_APP_BACKEND_URL}/invoices/${updatedRecord.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(updatedRecord),
        });

        refresh();
        setModalVisible(false);
      } catch (err) {
        errorHandler(err);
      }
    },
    [refresh, token]
  );

  const columns = [
    { title: 'Invoice ID', dataIndex: 'id', key: 'id' },
    { title: 'Contractor', dataIndex: ['lienWaiver', 'contractor'], key: 'contractor' },
    { title: 'Project', dataIndex: ['payAppClient', 'project', 'property', 'name'], key: 'project' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) =>
        !record.lienWaiver?.notaryImage ? (
          <>
            <Button type="primary" title="Lien Waiver" onClick={() => onLienClick(record)}>
              <EyeOutlined /> See Lien Waiver
            </Button>{' '}
            <Button type="primary" onClick={() => handleNotaryClick(record)}>
              Fill Lien
            </Button>
          </>
        ) : (
          <span>Signed</span>
        ),
    },
  ];

  const breadcrumb = (
    <BreadcrumbCustom>
      <Breadcrumb.Item href="/">{t('menus:home')}</Breadcrumb.Item>
      <Breadcrumb.Item>{t('menus:projects')}</Breadcrumb.Item>
      <Breadcrumb.Item>{t('menus:lienWaiver')}</Breadcrumb.Item>
    </BreadcrumbCustom>
  );

  return (
    <DefaultLayout breadcrumb={breadcrumb}>
      <PageTitle title={t('menus:lienWaiver')} />
      <Box>
        <Spin spinning={loading}>
          <h2>Invoices pending notarization</h2>
          <Table dataSource={invoices} rowKey="id" columns={columns} />

          {lienWaiverVisible && (
            <LienWaiverContract
              visible={lienWaiverVisible}
              onCancel={() => setLienWaiverVisible(false)}
              // onSave={data => {
              //   handleUpdateInvoice(data);
              //   setLienWaiverVisible(false);
              // }}
              selectedRecord={selectedRecord}
            />
          )}

          {modalVisible && (
            <NotaryLienModal
              visible={modalVisible}
              onCancel={() => setModalVisible(false)}
              onSave={handleSave}
              selectedRecord={selectedRecord}
            />
          )}
        </Spin>
      </Box>
    </DefaultLayout>
  );
}
